// extracted by mini-css-extract-plugin
export default {"ad":"Ad_ad__NIo4h"};